import styled from '@emotion/styled';
import { colors, fontSizes, fontWeights, gutterSizes, lineHeights } from '@gumtree/ui-library/src/base/theme';

export const ReviewItemWrapper = styled.div`
    padding: ${gutterSizes.xxlarge} 0;
    border-bottom: 1px solid ${colors.bark20};
    
    &:last-child {
        border-bottom: none;
    }
`;

export const ReviewerName = styled.div`
    font-weight: ${fontWeights.bold};
    color: ${colors.blade};
    margin-bottom: ${gutterSizes.base};
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const RatingRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.base};
    margin-bottom: ${gutterSizes.base};
`;

export const StarsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${gutterSizes.xsmall};
`;

export const StarIcon = styled.div`
    display: flex;
    align-items: center;
    
    svg {
        width: 17px;
        height: 16px;
    }
`;

export const ReviewDate = styled.span`
    font-size: ${fontSizes.smaller};
    color: ${colors.darkGrey};
`;

export const ReviewText = styled.p<{ $showFullText?: boolean }>`
    line-height: ${lineHeights.base24};
    color: ${colors.bark};
    margin: ${gutterSizes.base} 0;
    word-break: break-all;
    overflow-wrap: anywhere;
    
    ${({ $showFullText }) => !$showFullText && `
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    `}
`;

export const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: ${colors.navy};
    font-weight: ${fontWeights.bold};
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0;
    
    &:hover {
        text-decoration: underline;
    }
`;
